module.exports = __webpack_public_path__ + "img/headPic.0722ac95.png";